import { ShieldCheck } from 'lucide-react'
import type { Book } from '../types'
import './CleanInceptionBanner.css'

interface CleanInceptionBannerProps {
  book: Book
}

/**
 * Informational banner explaining the validation book's role: a permanent
 * platform canary on a clean-inception account, not a stepping stone that
 * eventually "graduates" into the live book. Purely derived from `book` —
 * no fetch needed.
 */
export function CleanInceptionBanner({ book }: CleanInceptionBannerProps) {
  const overlayVersion = book.bookStatus?.overlay_version ?? null

  return (
    <div className="card clean-inception-banner">
      <div className="clean-inception-banner-icon" aria-hidden="true">
        <ShieldCheck size={22} />
      </div>
      <div className="clean-inception-banner-body">
        <div className="clean-inception-banner-headline">Permanent validation canary</div>
        <p className="clean-inception-banner-text">
          This book proves the whole platform end-to-end on a clean-inception account.
          Its scorecard is the real-money graduation evidence — roughly six months of
          clean running is required before any live-money decision leans on it. It never
          itself "graduates" into live trading; the live book is a separate account that
          the platform must independently earn trust to run.
        </p>
        <div className="clean-inception-banner-meta">
          <span>{book.label ?? `Account ${book.id}`}</span>
          <span>·</span>
          <span>Overlay v<span className="num">{overlayVersion ?? '—'}</span></span>
        </div>
      </div>
    </div>
  )
}
